import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { Models } from './index';
import { ICaseStudyArticleData } from '../templates/case-study-article';
import { IEmployeeBoxProps } from '../components/employee-box/employee-box';
import { ICategoryModel } from './category-model';

export class CaseStudyArticleModel extends ContentItem {
  get id(): string {
    return get(this._config, 'id', '');
  }

  get language(): string {
    return get(this._config, 'system.language', '');
  }

  get slug(): string {
    return get(this._config, 'elements.basic_page_settings__url.value', '');
  }

  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get subTitle(): string {
    return get(this._config, 'elements.subtitle.value', '');
  }

  get summary(): string {
    return get(this._config, 'elements.summary.value', '');
  }

  get country(): string {
    const country = get(
      this._config,
      'elements.case_study_categories__country.value',
      null
    );

    const modeledCountry = country
      ? country.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : [];

    return modeledCountry[0] ? modeledCountry[0].categoryName : '';
  }

  get publicationDate(): string {
    return get(this._config, 'elements.publication_date.value', '');
  }

  get image(): {
    url: string;
    description: string;
  } {
    return get(this._config, 'elements.image.value[0]', '');
  }

  get author(): IEmployeeBoxProps {
    const authorData = get(this._config, 'elements.author.value[0]', {});
    const modeledData = Models.EmployeeBoxModel.create(
      authorData as IEmployeeBox
    );

    return modeledData;
  }

  get content(): {
    value: IKontentResolvedData;
    modular_content: IKontentItem[];
  } {
    return get(this._config, 'elements.content', '');
  }

  get tags(): ICategoryModel[] {
    const industry = get(
      this._config,
      'elements.case_study_categories__industry.value',
      null
    );

    const modeledIndustryData = industry
      ? industry.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : [];

    const technology = get(
      this._config,
      'elements.case_study_categories__technology.value',
      null
    );

    const modeledTechnologyData = technology
      ? technology.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : [];

    const project = get(
      this._config,
      'elements.case_study_categories__project.value',
      null
    );
    const modeledProjectData = project
      ? project.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : [];

    const country = get(
      this._config,
      'elements.case_study_categories__country.value',
      null
    );

    const modeledCountryData = country
      ? country.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : [];

    return [
      ...modeledIndustryData,
      ...modeledTechnologyData,
      ...modeledProjectData,
      ...modeledCountryData
    ];
  }

  public static create(data: ICaseStudyArticle): ICaseStudyArticleData {
    const {
      language,
      slug,
      title,
      summary,
      publicationDate,
      image,
      author,
      content,
      id,
      tags,
      country,
      subTitle
    } = new CaseStudyArticleModel(data);

    return {
      language,
      id,
      slug,
      title,
      summary,
      publicationDate,
      image,
      author,
      content,
      tags,
      country,
      subTitle
    };
  }
}
